import {arrayIntersection} from "./content";

export const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email)
};

export const isValidPassword = (password) => {
    if (!password) return false;
    return password.length >= 6;
};

export const iCan = (me, permissions) => {
    if (permissions.length === 0) {
        return true;
    }

    return !!me && arrayIntersection(permissions, me.permissions).length > 0;
}

export const iCant = (me, permissions) => {
    if (permissions.length === 0) {
        return false;
    }

    return !!me && arrayIntersection(permissions, me.permissions).length <= 0;
}
